import React, { useEffect } from "react";
import { TwitterPicker } from 'react-color';
import { CategoryInterface } from "../../../../store/sticker_maker/categoriesSlice";

import { Button, Collapse, Form, Input } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import { AVAILABLE_LOCALES_EXTEND } from "../../../../configs/constants";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import './_Form.scss';

const { Panel } = Collapse;

interface propsInterface {
  params: CategoryInterface;
  onFinish: Function;
  onClickFileDestroy?: Function | undefined;
}

const COLORS = [
  '#EA3468',
  '#5D5FEF',
  '#FBA018',
  '#B0EA34',
  '#34EAC9',
];

const _Form = ({ params, onFinish, onClickFileDestroy }: propsInterface) => {
  const [form] = Form.useForm();
  const locales: string[] = [...Object.keys(params.name_translations), ...params.empty_locales];
  const colorValue = Form.useWatch('color', form);
  const nameValue = Form.useWatch('name_translations', form)?.en || 'Untitled';

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderName = (locale: string) => {
    if (locale === 'en') {
      return null;
    }

    const prefix = params.name_translations[locale] ? <CheckOutlined style={{ color: '#52c41a' }} /> : <ExclamationCircleOutlined style={{ color: '#FBA018' }} />;

    return(
      <Form.Item
        key={locale}
        name={['name_translations', locale]}
        label={`${AVAILABLE_LOCALES_EXTEND[locale]} :${locale}`}
      >
        <Input placeholder={`Name_${locale}`} prefix={prefix} />
      </Form.Item>
    )
  }

  function handleColorChange(color: any) {
    form.setFieldsValue({ color: color.hex });
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone
          name='image'
          label='Image'
          preview={params?.image_url}
          onClickDestroy={onClickFileDestroy}
        />
      </div>

      <Form.Item name='target' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='color' label="Color" className='v-mb-0'>
        <Input type='hidden' />
      </Form.Item>

      <span
        className='v-categories-form--name_preview'
        style={{ borderColor: colorValue, color: colorValue }}
      >
        <span>{nameValue}</span>
      </span>

      <TwitterPicker
        className='v-mb-15'
        width='100%'
        colors={COLORS}
        color={colorValue}
        onChangeComplete={handleColorChange}
      />

      <Form.Item name={['name_translations', 'en']} label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Collapse ghost expandIconPosition='end'>
        <Panel header={null} key="1" extra={<>Name Translations</>}>
          { locales.map(renderName) }
        </Panel>
      </Collapse>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
